import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { API } from '.'


export const submitForm = createAsyncThunk(
   'form/submitForm',
   async values => {
      // values.formType === 'question' | 'contacts' | 'feedback'
      const response = await API.post('/form', values)
      return response.data
   },
   {
      condition: (_, { getState }) => {
         if (getState().form.loading) return false
      }
   }
)

const initialState = {
   loading: false,
   loaded: false,
   error: null
}

// formFeedback
const formSlice = createSlice({
   name: 'form',
   initialState,
   extraReducers: builder => {
      builder.addCase(submitForm.pending, state => {
         state.loading = true
         state.loaded = false
         state.error = null
      })
      builder.addCase(submitForm.fulfilled, state => {
         state.loading = false
         state.loaded = true
      })
      builder.addCase(submitForm.rejected, state => {
         state.loading = false
         state.loaded = false
         state.error = 'error'
      })
   }
})

export const form = formSlice.reducer
